// Permissões configuráveis por setor (ver tela /admin/permissoes e o
// endpoint GET /profile/permissoes no backend). Diferente dos outros
// arquivos em utils/acl/*, que comparam nome de setor direto no código,
// aqui a checagem é contra a lista de chaves já resolvida no login -
// admin (perfilId 99) sempre tem todas.
function getPermissoes() {
  try {
    return JSON.parse(localStorage.getItem('permissoes') || '[]');
  } catch (error) {
    return [];
  }
}

function isPermissoesAdmin() {
  return localStorage.getItem('permissoesAdmin') === 'true';
}

// `chaves` pode ser uma chave ou uma lista: com lista, basta ter QUALQUER UMA
// (mesma regra do requirePermissao do backend).
function hasPermissao(chaves) {
  if (isPermissoesAdmin()) return true;
  const permissoes = getPermissoes();
  const lista = Array.isArray(chaves) ? chaves : [chaves];
  return lista.some((chave) => permissoes.includes(chave));
}

// Quem vê as Tarefas de Contato: pelo menu próprio ou pela aba da ficha do cliente.
// Mesma lista que o backend aceita em GET /tarefas-contato.
const PERMISSOES_TAREFAS_CONTATO = ['menu.tarefasContato', 'pessoa.aba.tarefasContato'];

export {
  getPermissoes,
  isPermissoesAdmin,
  hasPermissao,
  PERMISSOES_TAREFAS_CONTATO,
};
